<template>
    <Former
        v-if="!success"
        :action="submit"
        :buttonLabel="$t('external.reset_password.reset')"
    >
        <div v-if="success" class="reset-password__success">
            {{ $t('external.reset_password.success') }}
        </div>

        <form-password
            v-model="password"
            ref="passwordRef"
            validators="required|password"
            :label="`${ $t('password') }*`"
        />

        <form-password
            v-model="password_again"
            ref="passwordAgainRef"
            validators="required"
            :label="`${ $t('password_again') }*`"
        />

        <span v-if="noMatch">{{ $t('external.reset_password.no_match') }}</span>
    </Former>

    <div v-if="success" class="reset-password__success">
        {{ $t('external.reset_password.success_reset') }}
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref, reactive, toRefs } from 'vue'
    import { resetPassword }  from '@services/auth/authDataService'
    import { currentLang }    from '@/helpers'
    import useValidate        from '@composables/useValidate'
    import Former             from '@components/form/Former.vue'
    import formPassword       from '@components/form/formPassword.vue'

    export default defineComponent({
        components: {
            Former,
            formPassword
        },
        setup() {
            const urlParams = new URLSearchParams(location.search);

            const passwordRef = ref<HTMLFormElement | null>(null)
            const passwordAgainRef = ref<HTMLFormElement | null>(null)

            const state = reactive({
                noMatch: null as null|boolean,
                success: false,
                email: urlParams.get('email') || '',
                token: urlParams.get('token') || '',
                password: '',
                password_again: ''
            })

            const submit = () => {
                let refsToValidate = {
                    'passwordRef': passwordRef.value,
                    'passwordAgainRef': passwordAgainRef.value
                }

                const hasError = useValidate(refsToValidate)

                state.noMatch = state.password !== state.password_again

                if (!hasError && !state.noMatch && state.token !== '' && state.email !== '') {
                    resetPassword({
                        password: state.password,
                        password_confirmation: state.password_again,
                        email: state.email,
                        token: state.token
                    }).then(response => {
                        state.success = response.status === 'Success'

                        setTimeout(() => {
                            state.success = false
                            location.href = `${ currentLang }/my-pages/login`
                        }, 3000)
                    })
                }
            }

            return {
                passwordRef,
                passwordAgainRef,
                ...toRefs(state),
                submit
            }
        }
    })
</script>
